import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '../lib/cn.js';
export const Separator = React.forwardRef(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (_jsx(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn('shrink-0 bg-[var(--color-border-default)]', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className), ...props })));
Separator.displayName = 'Separator';
//# sourceMappingURL=separator.js.map